import { gkApi } from './index';

const reservationApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    // Operator-facing endpoints (require login + "markt" group for writes).
    listReservations: builder.query({
      query: ({ status } = {}) => ({
        url: '/markt/reservation/',
        method: 'get',
        params: { status: status || undefined, limit: 500 },
      }),
      providesTags: [{ type: 'RESERVATION_LIST' }],
    }),
    createReservation: builder.mutation({
      query: (payload) => ({
        url: '/markt/reservation/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: [{ type: 'RESERVATION_LIST' }, { type: 'MARKT_STOCK' }],
    }),
    updateReservation: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/markt/reservation/${id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: [{ type: 'RESERVATION_LIST' }],
    }),
    confirmReservation: builder.mutation({
      query: (id) => ({
        url: `/markt/reservation/${id}/confirm/`,
        method: 'post',
      }),
      invalidatesTags: [{ type: 'RESERVATION_LIST' }, { type: 'MARKT_STOCK' }],
    }),
    cancelReservation: builder.mutation({
      query: (id) => ({
        url: `/markt/reservation/${id}/cancel/`,
        method: 'post',
      }),
      invalidatesTags: [{ type: 'RESERVATION_LIST' }, { type: 'MARKT_STOCK' }],
    }),
    deleteReservation: builder.mutation({
      query: (id) => ({ url: `/markt/reservation/${id}/`, method: 'delete' }),
      invalidatesTags: [{ type: 'RESERVATION_LIST' }, { type: 'MARKT_STOCK' }],
    }),

    // Public, login-free endpoints (no auth token attached when logged out).
    listPublicArticles: builder.query({
      query: () => ({ url: '/public/markt/articles/', method: 'get' }),
    }),
    createPublicReservation: builder.mutation({
      query: (payload) => ({
        url: '/public/markt/reservation/',
        method: 'post',
        body: payload,
      }),
    }),
  }),
});

export const {
  useListReservationsQuery,
  useCreateReservationMutation,
  useUpdateReservationMutation,
  useConfirmReservationMutation,
  useCancelReservationMutation,
  useDeleteReservationMutation,
  useListPublicArticlesQuery,
  useCreatePublicReservationMutation,
} = reservationApi;
